import { Box, Flex, PrimaryButton, QuietButton } from "@nulogy/components";
import Form from "components/controls/Form";
import Textarea from "components/controls/Textarea";
import useUpdateWorkOrder from "hooks/apollo/workOrder/useUpdateWorkOrder";
import React from "react";
import { useTheme } from "styled-components";

const EditNotes = ({ workOrderId: id, notes: workOrderNotes, readonly }) => {
  const updateWorkOrder = useUpdateWorkOrder();

  const handleSave = ({ notes }) => updateWorkOrder({ id, notes });

  const handleBeforeSave = (values, actions) => {
    actions.setFieldValue("notes", values.notes.trim());

    return values;
  };

  const theme = useTheme();

  return (
    <Form
      enableReinitialize
      initialValues={{ notes: workOrderNotes || "" }}
      onBeforeSave={handleBeforeSave}
      onSave={handleSave}
    >
      {({ dirty, handleReset, isSubmitting }) => (
        <>
          <Flex marginBottom="half">
            <Textarea
              disabled={readonly || isSubmitting}
              field="notes"
              id="work-order-details-notes"
              placeholder="Add a work order note..."
              rows={2}
              style={{ color: theme.colors.black, maxWidth: "100%", minWidth: "100%" }}
            />
          </Flex>
          {!readonly && (
            <Box marginTop="x1">
              <PrimaryButton disabled={!dirty || isSubmitting} mr="x1" size="small" type="submit">
                Save note
              </PrimaryButton>
              <QuietButton disabled={!dirty || isSubmitting} onClick={handleReset} size="small" type="button">
                Cancel
              </QuietButton>
            </Box>
          )}
        </>
      )}
    </Form>
  );
};

export default EditNotes;
